export const disabledDate = (current: any) => {
    // Lấy ngày hiện tại
    const today = new Date();

    // Đặt giờ, phút, giây, và millisecond về 0 để so sánh ngày
    today.setHours(0, 0, 0, 0);

    // Chỉ cho phép chọn ngày trong quá khứ hoặc ngày hiện tại
    return current && current.valueOf() > today;
  };